export const readJsonFromDom = <T>(selector: string): T | null => {
  const jsonData = document.querySelector(selector);
  if (jsonData) {
    try {
      const parser = new DOMParser();
      const decoded = parser.parseFromString(`<!doctype html><body>${jsonData.innerHTML}</body>`, 'text/html').body
        .textContent;
      return JSON.parse(decoded ?? 'null') as T | null;
    } catch (e) {
      console.error(`Failed to load JSON from DOM at '${selector}':`, e);
      return null;
    }
  } else {
    console.error(`Failed to find element at '${selector}'`);
    return null;
  }
};

export const debounceFn: <F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  waitFor: number,
) => (...args: Parameters<F>) => void = <F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  waitFor: number,
) => {
  let timeout: ReturnType<typeof setTimeout> | undefined;

  return (...args: Parameters<F>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), waitFor);
  };
};

let pageScrollPosition = 0;
const htmlBodyNoScrollClass = 'ents-no-scroll';
export const togglePageScrolling = (enabled: boolean) => {
  const shopBody = document.querySelector('.shop-body') as HTMLElement;
  const shopHtml = document.querySelector('.shop-html') as HTMLElement;
  if (!shopHtml || !shopBody) return;
  if (enabled && shopBody.classList.contains(htmlBodyNoScrollClass)) {
    shopBody.classList.remove(htmlBodyNoScrollClass);
    shopHtml.scrollTop = parseFloat(shopHtml.style.getPropertyValue('--scroll-top')) * -1;
  } else if (!enabled && !shopBody.classList.contains(htmlBodyNoScrollClass)) {
    pageScrollPosition = shopHtml.scrollTop;
    shopHtml.style.setProperty('--scroll-top', `${-pageScrollPosition}px`);
    shopBody.classList.add(htmlBodyNoScrollClass);
  }
};
